/**
 * IM 消息路由插件
 * 统一管理所有 IM 消息的分发和处理
 *
 * 职责：
 * 1. 注册所有消息类型的监听器
 * 2. 将消息路由到对应的处理函数
 * 3. 在应用卸载时清理监听器
 *
 * 架构说明：
 * - 消息处理函数统一放在 messageHandlers 目录下
 * - 每个模块负责特定类型的消息处理
 * - 通过配置数组 messageHandlers 统一注册和管理
 */

import { onMessage, offMessage, onAllMessages } from '@/events/messageEvents'
import { messageHandlers } from './messageHandlers'

// ========== Plugin 定义 ==========

export default {
  install(app) {
    // console.log('[MessageRouter] Installing message router plugin...')

    // ========== 注册所有消息监听器 ==========

    // 通过配置数组统一注册
    messageHandlers.forEach(({ msgType, handler }) => {
      onMessage(msgType, handler)
    })

    // 调试：监听所有消息
    if (import.meta.env.DEV) {
      onAllMessages((event) => {
        console.log('[MessageRouter] Message received:', event)
      })
    }

    // console.log('[MessageRouter] Message router installed successfully')

    // ========== 清理函数 ==========
    // 劫持 app.unmount，在应用卸载时清理监听器
    const originalUnmount = app.unmount
    app.unmount = function () {
      // console.log('[MessageRouter] Cleaning up message listeners...')

      // 移除所有消息监听器
      messageHandlers.forEach(({ msgType, handler }) => {
        offMessage(msgType, handler)
      })

      // 调用原始 unmount
      return originalUnmount.apply(this, arguments)
    }
  }
}

// ========== 导出处理函数（便于测试和直接引用） ==========
export * from './messageHandlers'
